//处理派发的事件并更新数据

import {
  ACTION_SET_PREVIEW_WORDS,
  ACTION_SET_SIGN_WORDS,
  ACTION_SET_REMOVE_WORDS,
  ACTION_SET_DELETE_WORD,
  ACTION_SET_HAVE_WORDS_COUNT,
  ACTION_SET_ADD_NEW_WORDS,
  ACTION_SET_ADD_PREVIEW_WORD,
  ACTION_SET_DELETE_NOT_WORD,
  ACTION_SET_EXISTING_WORDS_IN_ARTICLE,
} from "./action";

export default {
  //拆解的单词信息
  preview_words(words = [], action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_PREVIEW_WORDS:
        return payload;
      case ACTION_SET_DELETE_WORD:
        console.log(words, payload);
        let newWords = words.slice();
        const index = newWords.findIndex(
          (item) =>
            item.bridge_id === payload.bridge_id ||
            (item.word === payload.word && item.idx === payload.idx)
        );
        if (index !== -1) {
          newWords.splice(index, 1);
        }
        return newWords;
      case ACTION_SET_ADD_PREVIEW_WORD:
        let _words = [...words];
        if (!_words.find((item) => item.word === payload.word)) {
          _words.push(payload);
        }

        return _words;
    }
    return words;
  },
  sign_words(state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_SIGN_WORDS:
        return payload;
    }
    return state;
  },
  remove_words(state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_REMOVE_WORDS:
        return payload;
      case ACTION_SET_DELETE_NOT_WORD:
        let newWords = state.slice();
        const index = newWords.findIndex(
          (item) =>
            item.cacheWordId === payload.cacheWordId ||
            item.id === payload.id ||
            (item.word === payload.word && item.idx === payload.idx)
        );
        if (index !== -1) {
          newWords.splice(index, 1);
        }
        return newWords;
    }
    return state;
  },
  add_new_words(state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_ADD_NEW_WORDS:
        return payload;
    }
    return state;
  },
  have_words_count(state = 0, action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_HAVE_WORDS_COUNT:
        return payload;
    }
    return state;
  },
  existing_words_in_article(state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_EXISTING_WORDS_IN_ARTICLE:
        return payload || [];
    }
    return state;
  },
};
